import React, { useCallback } from "react";

import { IntegrationLogo } from "./components/Logos/Logos";
import { graphql, useMutation } from "react-relay";
import { IntegrationFlourishCreateScreenMutation } from "./__generated__/IntegrationFlourishCreateScreenMutation.graphql";
import { useAlert } from "../../common/Alert";

import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { IntegrationSettings } from "./components/IntegrationSettings";
import { Box } from "arkh";

export function IntegrationFlourish(props: {
  mode: "create" | "edit";
  onCompleted: () => void;
}) {
  switch (props.mode) {
    case "create":
      return <FlourishCreate onCompleted={props.onCompleted} />;
    case "edit":
      return <FlourishEdit onCompleted={props.onCompleted} />;
    default:
      return null;
  }
}

function FlourishCreate({ onCompleted }: { onCompleted: () => void }) {
  const [value, setValue] = React.useState("");

  const isValid = value.length > 1;

  const [create, loading] =
    useMutation<IntegrationFlourishCreateScreenMutation>(graphql`
      mutation IntegrationFlourishCreateScreenMutation($authToken: String!) {
        store {
          activateIntegrationFlourish(authToken: $authToken)
        }
      }
    `);

  const Alert = useAlert();

  const onCreate = useCallback(() => {
    create({
      onCompleted: (d) => {
        if (d.store.activateIntegrationFlourish) {
          onCompleted();
        } else {
          Alert.error(
            "Fel Uppstod",
            "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt kod "
          );
        }
      },
      variables: { authToken: value },
    });
  }, [Alert, create, onCompleted, value]);

  return (
    <IntegrationActivateScreen
      onActivate={onCreate}
      isValid={isValid}
      isActivating={loading}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="flourish" />}
          description=""
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={value}
          onChangeText={setValue}
          type="api-key"
        />
      }
    />
  );
}

function FlourishEdit({ onCompleted }: { onCompleted: () => void }) {
  const [deleteIntegration, pending] = useMutation(graphql`
    mutation IntegrationFlourishDeleteMutation {
      store {
        deleteIntegrationFlourish
      }
    }
  `);
  const requestDelete = () => {
    deleteIntegration({
      variables: {},
      onCompleted,
    });
  };
  return (
    <IntegrationSettings
      delete={{
        pending,
        requestDelete,
      }}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="flourish" />}
          description=""
        />
      }
      body={<Box />}
    />
  );
}
